class HasthrangStickyAtc {
  constructor(element) {
    this.element = element;
    this.formId = element.dataset.productFormId;
    this.form = document.getElementById(this.formId);
    this.variantSelect = element.querySelector('[data-hasthrang-sticky-variant]');
    this.quantityInput = element.querySelector('[data-hasthrang-sticky-quantity]');
    this.minusButton = element.querySelector('[data-hasthrang-sticky-minus]');
    this.plusButton = element.querySelector('[data-hasthrang-sticky-plus]');
    this.submitButton = element.querySelector('[data-hasthrang-sticky-submit]');
    this.price = element.querySelector('[data-hasthrang-sticky-price]');
    this.compare = element.querySelector('[data-hasthrang-sticky-compare]');
    this.error = element.querySelector('[data-hasthrang-sticky-error]');

    if (!this.form || !this.variantSelect || !this.quantityInput || !this.submitButton) return;

    this.bindEvents();
    this.bindVisibility();
    this.syncVariant();
  }

  bindEvents() {
    this.variantSelect.addEventListener('change', () => this.syncVariant());
    this.minusButton?.addEventListener('click', () => this.adjustQuantity(-1));
    this.plusButton?.addEventListener('click', () => this.adjustQuantity(1));
    this.submitButton.addEventListener('click', () => this.submit());

    document.addEventListener('hasthrang:cart-error', (event) => {
      this.setLoading(false);
      this.showError(event.detail?.message || window.cartStrings?.error || 'Unable to add item to cart.');
    });

    document.addEventListener('hasthrang:cart-added', () => {
      this.setLoading(false);
      this.showError('');
    });
  }

  bindVisibility() {
    const mainButton = document.querySelector(`#ProductSubmitButton-${this.formId.replace('product-form-', '')}`);

    if (!mainButton || !('IntersectionObserver' in window)) {
      this.element.hidden = window.scrollY < 500;
      window.addEventListener('scroll', () => {
        this.element.hidden = window.scrollY < 500;
      }, { passive: true });
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        this.element.hidden = entry.isIntersecting;
      },
      { threshold: 0 }
    );
    observer.observe(mainButton);
  }

  syncVariant() {
    const option = this.variantSelect.selectedOptions[0];
    if (!option) return;

    const isAvailable = option.dataset.available === 'true';
    this.submitButton.disabled = !isAvailable;
    this.submitButton.textContent = isAvailable ? window.variantStrings?.addToCart || 'Add to cart' : window.variantStrings?.soldOut || 'Sold out';
    this.price.textContent = option.dataset.price || '';

    if (option.dataset.compare) {
      this.compare.textContent = option.dataset.compare;
      this.compare.hidden = false;
    } else {
      this.compare.hidden = true;
    }
  }

  adjustQuantity(direction) {
    const step = parseInt(this.quantityInput.step, 10) || 1;
    const min = parseInt(this.quantityInput.min, 10) || 1;
    const current = parseInt(this.quantityInput.value, 10) || min;
    this.quantityInput.value = Math.max(min, current + (direction * step));
  }

  submit() {
    const option = this.variantSelect.selectedOptions[0];
    if (!option || option.dataset.available !== 'true') return;

    const variantInput = this.form.querySelector('[name="id"]');
    const quantityInput = this.form.querySelector('[name="quantity"]');

    if (!variantInput) {
      this.showError(window.cartStrings?.error || 'Unable to add item to cart.');
      return;
    }

    variantInput.value = this.variantSelect.value;
    variantInput.disabled = false;

    if (quantityInput) {
      quantityInput.value = Math.max(parseInt(this.quantityInput.min, 10) || 1, parseInt(this.quantityInput.value, 10) || 1);
    }

    this.showError('');
    this.setLoading(true);

    if (typeof this.form.requestSubmit === 'function') {
      this.form.requestSubmit();
    } else {
      this.form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }
  }

  setLoading(isLoading) {
    const isAvailable = this.variantSelect.selectedOptions[0]?.dataset.available === 'true';
    this.submitButton.disabled = isLoading || !isAvailable;
    this.submitButton.textContent = isLoading
      ? 'Adding...'
      : isAvailable
        ? window.variantStrings?.addToCart || 'Add to cart'
        : window.variantStrings?.soldOut || 'Sold out';
  }

  showError(message) {
    if (this.error) this.error.textContent = message || '';
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-hasthrang-sticky-atc]').forEach((element) => {
    new HasthrangStickyAtc(element);
  });
});
